module.exports = __webpack_public_path__ + "img/dang4.212badb7.png";